import { ComplexValue } from 'app/types-shared';
import { CodeItem, ReceiveCodeItemPayload } from './types-store';
import { ValidationProps } from 'ui/common/validation/types';
import { CodetableFeature, CodeFieldWireKey } from 'app/area/codetable/types-store';
import { ScreenField, ScreenPicker } from 'app/area/codetable/item/screen-renderer/types';

export const ACTION = {
  REQUEST_CODE_ITEM: 'CODETABLE_ADMINISTRATION_ITEM:REQUEST_CODE_ITEM',
  RECEIVE_CODE_ITEM: 'CODETABLE_ADMINISTRATION_ITEM:RECEIVE_CODE_ITEM',
  FAIL_CODE_ITEM: 'CODETABLE_ADMINISTRATION_ITEM:FAIL_CODE_ITEM',

  REQUEST_CREATE_CODE_ITEM: 'CODETABLE_ADMINISTRATION_ITEM:REQUEST_CREATE_CODE_ITEM',
  RECEIVE_CREATE_CODE_ITEM: 'CODETABLE_ADMINISTRATION_ITEM:RECEIVE_CREATE_CODE_ITEM',
  FAIL_CREATE_CODE_ITEM: 'CODETABLE_ADMINISTRATION_ITEM:FAIL_CREATE_CODE_ITEM',

  REQUEST_SAVE_CODETABLE_ITEM: 'CODETABLE_ADMINISTRATION_ITEM:REQUEST_SAVE_CODETABLE_ITEM',
  RECEIVE_SAVE_CODETABLE_ITEM: 'CODETABLE_ADMINISTRATION_ITEM:RECEIVE_SAVE_CODETABLE_ITEM',
  FAIL_SAVE_CODETABLE_ITEM: 'CODETABLE_ADMINISTRATION_ITEM:FAIL_SAVE_CODETABLE_ITEM',

  REQUEST_CODE_ITEM_DELETE: 'CODETABLE_ADMINISTRATION_ITEM:REQUEST_CODE_ITEM_DELETE',
  RECEIVE_CODE_ITEM_DELETE: 'CODETABLE_ADMINISTRATION_ITEM:RECEIVE_CODE_ITEM_DELETE',
  FAIL_CODE_ITEM_DELETE: 'CODETABLE_ADMINISTRATION_ITEM:FAIL_CODE_ITEM_DELETE',

  UPDATE_LIST_NODE: 'CODETABLE_ADMINISTRATION_ITEM:UPDATE_LIST_NODE',
  UPDATE_PARENT: 'CODETABLE_ADMINISTRATION_ITEM:UPDATE_PARENT',
  UPDATE_DISABLED: 'CODETABLE_ADMINISTRATION_ITEM:UPDATE_DISABLED',
  UPDATE_USER_GROUPS: 'CODETABLE_ADMINISTRATION_ITEM:UPDATE_USER_GROUPS',
  UPDATE_EXCLUDED_FIELDS: 'CODETABLE_ADMINISTRATION_ITEM:UPDATE_EXCLUDED_FIELDS',
  UPDATE_CASE_TYPES: 'CODETABLE_ADMINISTRATION_ITEM:UPDATE_CASE_TYPES',
  UPDATE_CODE_CATEGORY: 'CODETABLE_ADMINISTRATION_ITEM:UPDATE_CODE_CATEGORY',
  UPDATE_SEQUENCE: 'CODETABLE_ADMINISTRATION_ITEM:UPDATE_SEQUENCE',
  UPDATE_ICON: 'CODETABLE_ADMINISTRATION_ITEM:UPDATE_ICON',
  UPDATE_COLOUR: 'CODETABLE_ADMINISTRATION_ITEM:UPDATE_COLOUR',
  UPDATE_COLOUR_CODE: 'CODETABLE_ADMINISTRATION_ITEM:UPDATE_COLOUR_CODE',
  UPDATE_MEASUREMENT_SYSTEM: 'CODETABLE_ADMINISTRATION_ITEM:UPDATE_MEASUREMENT_SYSTEM',
  UPDATE_UOM_CONVERSION: 'CODETABLE_ADMINISTRATION_ITEM:UPDATE_UOM_CONVERSION',
  UPDATE_UOM_CONVERSION_FACTOR_ITEM: 'CODETABLE_ADMINISTRATION_ITEM:UPDATE_UOM_CONVERSION_FACTOR_ITEM',
  UPDATE_ACTIVE_MODE: 'CODETABLE_ADMINISTRATION_ITEM:UPDATE_ACTIVE_MODE',
  UPDATE_DESCRIPTION: 'CODETABLE_ADMINISTRATION_ITEM:UPDATE_DESCRIPTION',
  UPDATE_LONG_DESCRIPTION: 'CODETABLE_ADMINISTRATION_ITEM:UPDATE_LONG_DESCRIPTION',
  UPDATE_CODETABLE_TYPES: 'CODETABLE_ADMINISTRATION_ITEM:UPDATE_CODETABLE_TYPES',

  SAVE_FOR_ALL_FIELDS_DESCRIPTION: 'CODETABLE_ADMINISTRATION_ITEM:SAVE_FOR_ALL_FIELDS_DESCRIPTION',
  SAVE_FOR_ALL_FIELDS_LONG_DESCRIPTION: 'CODETABLE_ADMINISTRATION_ITEM:SAVE_FOR_ALL_FIELDS_LONG_DESCRIPTION',

  COPY_DESCRIPTION_TO_ALL_TRANSLATIONS: 'CODETABLE_ADMINISTRATION_ITEM:COPY_DESCRIPTION_TO_ALL_TRANSLATIONS',
  COPY_LONG_DESCRIPTION_TO_ALL_TRANSLATIONS: 'CODETABLE_ADMINISTRATION_ITEM:COPY_LONG_DESCRIPTION_TO_ALL_TRANSLATIONS',

  UPDATE_VALIDATION: 'CODETABLE_ADMINISTRATION_ITEM:UPDATE_VALIDATION',
  RESET_VALIDATION: 'CODETABLE_ADMINISTRATION_ITEM:RESET_VALIDATION',
  RESET_DESCRIPTION_VALIDATION: 'CODETABLE_ADMINISTRATION_ITEM:RESET_DESCRIPTION_VALIDATION',
  RESET_LONG_DESCRIPTION_VALIDATION: 'CODETABLE_ADMINISTRATION_ITEM:RESET_LONG_DESCRIPTION_VALIDATION',
  RESET_ALL_DESCRIPTIONS_VALIDATION: 'CODETABLE_ADMINISTRATION_ITEM:RESET_ALL_DESCRIPTIONS_VALIDATION',
  RESET_ALL_LONG_DESCRIPTIONS_VALIDATION: 'CODETABLE_ADMINISTRATION_ITEM:RESET_ALL_LONG_DESCRIPTIONS_VALIDATION',
  UPDATE_BY_KEY: 'CODETABLE_ADMINISTRATION_ITEM:UPDATE_BY_KEY',
  UPDATE_ORIGINAL_CODE_BY_KEY: 'CODETABLE_ADMINISTRATION_ITEM:UPDATE_ORIGINAL_CODE_BY_KEY',
  CLEAR_VALIDATION: 'CODETABLE_ADMINISTRATION_ITEM:CLEAR_VALIDATION',

  SWITCH_TRANSLATIONS_TOGGLE: 'CODETABLE_ADMINISTRATION_ITEM:SWITCH_TRANSLATIONS_TOGGLE',

  CLEAR_CODETABLE_OPTIONS: 'CODETABLE_ADMINISTRATION_ITEM:CLEAR_CODETABLE_OPTIONS',

  REQUEST_PARENT_CATEGORY: 'CODETABLE_ADMINISTRATION_ITEM:REQUEST_PARENT_CATEGORY',
  RECEIVE_PARENT_CATEGORY: 'CODETABLE_ADMINISTRATION_ITEM:RECEIVE_PARENT_CATEGORY',
  FAIL_PARENT_CATEGORY: 'CODETABLE_ADMINISTRATION_ITEM:FAIL_PARENT_CATEGORY',

  REQUEST_CHECK_IS_UOM_EXCLUDED: 'CODETABLE_ADMINISTRATION_ITEM:REQUEST_CHECK_IS_UOM_EXCLUDED',
  RECEIVE_CHECK_IS_UOM_EXCLUDED: 'CODETABLE_ADMINISTRATION_ITEM:RECEIVE_CHECK_IS_UOM_EXCLUDED',
  FAIL_CHECK_IS_UOM_EXCLUDED: 'CODETABLE_ADMINISTRATION_ITEM:FAIL_CHECK_IS_UOM_EXCLUDED',

  REQUEST_UOM_CONVERSION_FACTORS: 'CODETABLE_ADMINISTRATION_ITEM:REQUEST_UOM_CONVERSION_FACTORS',
  RECEIVE_UOM_CONVERSION_FACTORS: 'CODETABLE_ADMINISTRATION_ITEM:RECEIVE_UOM_CONVERSION_FACTORS',
  FAIL_UOM_CONVERSION_FACTORS: 'CODETABLE_ADMINISTRATION_ITEM:FAIL_UOM_CONVERSION_FACTORS',
  CREATE_INITIAL_UOM_CONVERSION_FACTORS: 'CODETABLE_ADMINISTRATION_ITEM:CREATE_INITIAL_UOM_CONVERSION_FACTORS',

  CLEAR_UOM_CONVERSION_FACTORS: 'CODETABLE_ADMINISTRATION_ITEM:CLEAR_UOM_CONVERSION_FACTORS',
  CLEAR_UOM_EXCLUDED: 'CODETABLE_ADMINISTRATION_ITEM:CLEAR_UOM_EXCLUDED'
};

export class RequestCodeItem {
  public type: string = ACTION.REQUEST_CODE_ITEM;
  constructor(public codetableId: number, public codeId: number) {
  }
}

export class ReceiveCodeItem {
  public type: string = ACTION.RECEIVE_CODE_ITEM;
  constructor(public payload: ReceiveCodeItemPayload) {
  }
}

export class FailCodeItem {
  public type: string = ACTION.FAIL_CODE_ITEM;
  constructor(public codetableId: number, public codeId: number) {
  }
}

export class RequestCreateCodeItem {
  public type: string = ACTION.REQUEST_CREATE_CODE_ITEM;
}

export class ReceiveCreateCodeItem {
  public type: string = ACTION.RECEIVE_CREATE_CODE_ITEM;
  constructor(public codeItem: CodeItem) {
  }
}

export class FailCreateCodeItem {
  public type: string = ACTION.FAIL_CREATE_CODE_ITEM;
}

export class RequestCodeItemDelete {
  public type: string = ACTION.REQUEST_CODE_ITEM_DELETE;
  constructor(public codetableId: number, public codeId: number) {
  }
}

export class ReceiveCodeItemDelete {
  public type: string = ACTION.RECEIVE_CODE_ITEM_DELETE;
  constructor(public codeId: number) {
  }
}

export class FailCodeItemDelete {
  public type: string = ACTION.FAIL_CODE_ITEM_DELETE;
  constructor(public codeId: number) {
  }
}

export class UpdateListNode {
  public type: string = ACTION.UPDATE_LIST_NODE;
  constructor(public node: ComplexValue<number>) {
  }
}

export class UpdateParent {
  public type: string = ACTION.UPDATE_PARENT;
  constructor(public parent: ComplexValue<number>) {
  }
}

export class UpdateDescription {
  public type: string = ACTION.UPDATE_DESCRIPTION;
  constructor(public languageId: number, public description: ComplexValue<number>[]) {
  }
}

export class UpdateLongDescription {
  public type: string = ACTION.UPDATE_LONG_DESCRIPTION;
  constructor(public languageId: number, public longDescription: ComplexValue<number>[]) {
  }
}

export class UpdateDisabled {
  public type: string = ACTION.UPDATE_DISABLED;
  constructor(public disabled: Date) {
  }
}

export class UpdateUserGroups {
  public type: string = ACTION.UPDATE_USER_GROUPS;
  constructor(public userGroups: ComplexValue<number>[]) {
  }
}

export class UpdateExcludedFields {
  public type: string = ACTION.UPDATE_EXCLUDED_FIELDS;
  constructor(public excludedFields: ComplexValue<number>[]) {
  }
}

export class UpdateCaseTypes {
  public type: string = ACTION.UPDATE_CASE_TYPES;
  constructor(public caseTypes: ComplexValue<number>[]) {
  }
}

export class UpdateCodetableTypes {
  public type: string = ACTION.UPDATE_CODETABLE_TYPES;
  constructor(public codetableTypes: ComplexValue<number>[]) {
  }
}

export class UpdateCodeCategory {
  public type: string = ACTION.UPDATE_CODE_CATEGORY;
  constructor(public codeCategory: ComplexValue<number>) {
  }
}

export class UpdateSequence {
  public type: string = ACTION.UPDATE_SEQUENCE;
  constructor(public sequence: number) {
  }
}

export class UpdateIcon {
  public type: string = ACTION.UPDATE_ICON;
  constructor(public icon: string) {
  }
}

export class UpdateColour {
  public type: string = ACTION.UPDATE_COLOUR;
  constructor(public colour: number) {
  }
}

export class UpdateColourCode {
  public type: string = ACTION.UPDATE_COLOUR_CODE;
  constructor(public colourCode: ComplexValue<number>) {
  }
}

export class UpdateMeasurementSystem {
  public type: string = ACTION.UPDATE_MEASUREMENT_SYSTEM;
  constructor(public measurementSystem: ComplexValue<number>) {
  }
}

export class UpdateUomConversion {
  public type: string = ACTION.UPDATE_UOM_CONVERSION;
  constructor(public uomConversion: ComplexValue<number>[]) {
  }
}

export class UpdateUomConversionFactorItem {
  public type: string = ACTION.UPDATE_UOM_CONVERSION_FACTOR_ITEM;
  constructor(public id: number, public value: number) {
  }
}

export class RequestSaveCodetableItem {
  public type: string = ACTION.REQUEST_SAVE_CODETABLE_ITEM;
}

export class ReceiveSaveCodetableItem {
  public type: string = ACTION.RECEIVE_SAVE_CODETABLE_ITEM;
}

export class FailSaveCodetableItem {
  public type: string = ACTION.FAIL_SAVE_CODETABLE_ITEM;
}

export class CopyDescriptionToAllTranslations {
  public type: string = ACTION.COPY_DESCRIPTION_TO_ALL_TRANSLATIONS;
  constructor(public description: ComplexValue<number>[]) {
  }
}

export class CopyLongDescriptionToAllTranslations {
  public type: string = ACTION.COPY_LONG_DESCRIPTION_TO_ALL_TRANSLATIONS;
  constructor(public longDescription: ComplexValue<number>[]) {
  }
}

export class UpdateValidation {
  public type: string = ACTION.UPDATE_VALIDATION;
  constructor(public validation: { [key: string]: ValidationProps }) {
  }
}

export class ResetValidation {
  public type: string = ACTION.RESET_VALIDATION;
  constructor(public key: CodetableFeature | CodeFieldWireKey | ScreenField | ScreenPicker | string) {
  }
}

export class ResetDescriptionValidation {
  public type: string = ACTION.RESET_DESCRIPTION_VALIDATION;
  constructor(public languageId: number) {
  }
}

export class ResetLongDescriptionValidation {
  public type: string = ACTION.RESET_LONG_DESCRIPTION_VALIDATION;
  constructor(public languageId: number) {
  }
}

export class ResetAllDescriptionsValidation {
  public type: string = ACTION.RESET_ALL_DESCRIPTIONS_VALIDATION;
}

export class ResetAllLongDescriptionsValidation {
  public type: string = ACTION.RESET_ALL_LONG_DESCRIPTIONS_VALIDATION;
}

export class ClearValidation {
  public type: string = ACTION.CLEAR_VALIDATION;
}

export class SwitchTranslationsToggle {
  public type: string = ACTION.SWITCH_TRANSLATIONS_TOGGLE;
  constructor(public toggled?: boolean) {
  }
}

export class ClearCodetableOptions {
  public type: string = ACTION.CLEAR_CODETABLE_OPTIONS;
}

export class UpdateByKey {
  public type: string = ACTION.UPDATE_BY_KEY;
  constructor(public key: string, public value: any) {
  }
}

export class UpdateOriginalCodeByKey {
  public type: string = ACTION.UPDATE_ORIGINAL_CODE_BY_KEY;
  constructor(public key: string, public value: any) {
  }
}

export class RequestParentCategory {
  public type: string = ACTION.REQUEST_PARENT_CATEGORY;
}

export class ReceiveParentCategory {
  public type: string = ACTION.RECEIVE_PARENT_CATEGORY;
}

export class FailParentCategory {
  public type: string = ACTION.FAIL_PARENT_CATEGORY;
}

export class RequestCheckIsUomExcluded {
  public type: string = ACTION.REQUEST_CHECK_IS_UOM_EXCLUDED;
}

export class ReceiveCheckIsUomExcluded {
  public type: string = ACTION.RECEIVE_CHECK_IS_UOM_EXCLUDED;
  constructor(public isUomExcluded: boolean) {
  }
}

export class FailCheckIsUomExcluded {
  public type: string = ACTION.FAIL_CHECK_IS_UOM_EXCLUDED;
}

export class RequestUomConversionFactors {
  public type: string = ACTION.REQUEST_UOM_CONVERSION_FACTORS;
}

export class ReceiveUomConversionFactors {
  public type: string = ACTION.RECEIVE_UOM_CONVERSION_FACTORS;
  constructor(public data: ComplexValue<number>[]) {
  }
}

export class FailUomConversionFactors {
  public type: string = ACTION.FAIL_UOM_CONVERSION_FACTORS;
}

export class CreateInitialUomConversionFactors {
  public type: string = ACTION.CREATE_INITIAL_UOM_CONVERSION_FACTORS;
  constructor(public uomConversionFactors: ComplexValue<number>[]) {
  }
}

export class ClearUomConversionFactors {
  public type: string = ACTION.CLEAR_UOM_CONVERSION_FACTORS;
}

export class ClearUomExcluded {
  public type: string = ACTION.CLEAR_UOM_EXCLUDED;
}
